import { Grid } from "@mui/material";
import {
  AutocompleteInput,
  DateTimeInput,
  ReferenceInput,
  TextInput,
  required,
  useRecordContext,
} from "react-admin";
import { administrationRequests } from "api/administrationApi";
import { urlValidator } from "utils/validations";

const SaveForm = () => {
  const record = useRecordContext();
  const facultyDisabled = !!record?.id;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <TextInput
          label="Име на български език"
          source="nameBg"
          validate={required()}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInput
          label="Име на английски език"
          source="nameEn"
          validate={required()}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <ReferenceInput
          source="structuralUnitId"
          reference={administrationRequests.getStructuralUnitsSelect()}
        >
          <AutocompleteInput
            label="Факултет"
            optionText={r => r?.name ?? ""}
            fullWidth
            disabled={facultyDisabled}
            validate={required()}
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>
      <Grid item xs={12} md={3}>
        <DateTimeInput
          label="От дата"
          source="dateFrom"
          validate={required()}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <DateTimeInput
          label="До дата"
          source="dateTo"
          validate={required()}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInput
          label="Линк към конспект по език"
          source="languageConspectLink"
          validate={[required(), urlValidator]}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

export default SaveForm;
